export let restoreAll = "ffT9qe";
export default {restoreAll};